const dashboard = '/admin/dashboard';
const transactionGeneral = '/admin/transaction/transactions';
const orderGeneral = '/admin/transaction/order';
const orderList = '/admin/transaction/order/list';
const orderDetail = '/admin/transaction/order/detail';
const userGeneral = '/admin/user';
const userList = '/admin/setting/user/list';
const userDetail = '/admin/setting/user/detail';
const fieldGeneral = '/admin/field';
const fieldDetail = '/admin/field/detail';
const fieldModify = '/admin/field/modify';
const accountantGeneral = '/admin/transaction/accountant';
const me = '/admin/me';
const calendar = '/admin/calendar';
const favorite = '/admin/favorite';
const order = '/admin/order';
const settingGeneral = '/admin/setting';
const settingFavorite = '/admin/setting/favorite';
const settingMe = '/admin/setting/me';
const internalNoticeGeneral = '/admin/internal-notice';
const privateNoteGeneral = '/admin/private-note';
const staffGeneral = '/admin/staff';
const customerSupportChat = '/customer-support-chat';

export const ALLOWED = {
  STAFF: [dashboard, fieldGeneral, me, orderGeneral, calendar, transactionGeneral, favorite, order, settingGeneral, settingMe, internalNoticeGeneral, privateNoteGeneral, customerSupportChat],
  VIETNAM: [dashboard, fieldGeneral, settingGeneral, internalNoticeGeneral, privateNoteGeneral],
};

export function returnDefaultPath(user) {
  if (!user) {
    return null;
  }
  if (!user.isStaff) {
    return dashboard;
  }
  //현재 직원 말고 다른 분류가 없음.
  const department = 'STAFF';
  return ALLOWED[department][0];
}

export function checkPermission(user, pathname, navigate) {
  let isAllowed = validPermission(user, pathname);
  if (!isAllowed) {
    let defaultPath = returnDefaultPath(user);
    navigate(defaultPath);
  }
}

export function validPermission(user, pathname) {
  const { isStaff } = user;

  if (user.phoneCountry === '84') {
    for (let url of ALLOWED['VIETNAM']) {
      if (pathname.startsWith(url)) {
        return true;
      }
    }
    return false;
  }

  if (!isStaff) {
    return true;
  }
  //현재 직원 말고 다른 분류가 없음.
  const department = 'STAFF';
  if (!ALLOWED[department]) {
    return false;
  }
  for (let url of ALLOWED[department]) {
    if (pathname.startsWith(url)) {
      return true;
    }
  }
  return false;
}

export function sidebarValidPermission(user, pathname) {
  const { isStaff } = user;

  if (user.phoneCountry === '84') {
    for (let url of ALLOWED['VIETNAM']) {
      if (pathname.startsWith(url)) {
        return true;
      }
    }
    return false;
  }

  if (!isStaff) {
    return true;
  }
  //현재 직원 말고 다른 분류가 없음.
  const department = 'STAFF';
  if (!ALLOWED[department]) {
    return false;
  }
  for (let url of ALLOWED[department]) {
    if (pathname.startsWith(url)) {
      return true;
    }
  }
  return false;
}

export function subSidebarValidPermission(user, pathname) {
  const { isStaff } = user;
  if (!isStaff) {
    return true;
  }
  const department = 'STAFF';
  if (!ALLOWED[department]) {
    return false;
  }
  for (let url of ALLOWED[department]) {
    if (url.startsWith(pathname)) {
      return true;
    }
  }
  return false;
}
